import { useEffect } from 'react';
import { Button, Row } from 'react-bootstrap';
import MultipleOrganizations from './MultipleOrgs';
import { ReactComponent as GcpLogo } from '../../../../icons/google-cloud-seeklogo.com.svg';
import './index.scss';

const OrganizationMediaObject = ({ organization }) => (
  <div className="d-flex gap-6 align-items-center text-truncate">
    <GcpLogo className="org-provider-icon" />
    <div className="text-truncate">
      <header className="text-truncate">
        {organization.displayName}
      </header>
      <small className="d-block text-muted text-truncate">{organization.name}</small>
    </div>
  </div>
);

const SingleOrganization = ({ organizations, result, setCurrentStepResult }) => {
  useEffect(() => {
    if (!result || result.googleOrganization.displayName !== organizations[0].displayName) {
      setCurrentStepResult({ googleOrganization: { ...organizations[0] } });
    }
  });
  return (
    <Row className="mb-4 ms-1 p-3 border bg-light">
      <OrganizationMediaObject organization={organizations[0]} />
    </Row>
  );
};

const OrganizationsPresent = ({
  organizations, setCurrentStepResult, result, handleLogout,
}) => {
  const hasOnlyOneOrg = organizations.length === 1;
  const oneOrg = {
    caption: (
      <small className="d-block text-gray700">
        Don&apos;t see the organization you&apos;re looking for?
        Try
        {' '}
        <Button onClick={handleLogout} size="sm" variant="link" className="p-0">signing in with a different Google account.</Button>
      </small>
    ),
    preliminaryText: (
      <p>
        We&apos;ve located your Google organization:
      </p>
    ),
  };
  const multiOrg = {
    caption: (
      <span>
        Only one Google organization can be associated with a Rackspace account,
        and all managed projects must belong to that organization.
      </span>
    ),
    preliminaryText: (
      <p>
        <strong>We&apos;ve found multiple Google organizations on your account.</strong>
        <br />
        Select the organization you want Rackspace to manage:
      </p>
    ),
  };
  return (
    <div>
      {
        hasOnlyOneOrg
          ? (
            <div>
              {oneOrg.preliminaryText}
              <SingleOrganization
                organizations={organizations}
                setCurrentStepResult={setCurrentStepResult}
                result={result}
              />
              {oneOrg.caption}
            </div>
          )
          : (
            <div>
              {multiOrg.preliminaryText}
              <MultipleOrganizations organizations={organizations} setCurrentStepResult={setCurrentStepResult} result={result} />
              {multiOrg.caption}
            </div>
          )
      }
    </div>
  );
};

export default OrganizationsPresent;
